// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dialog Title */

/* Dialog Content */
mat-dialog-content {
  min-width: 1100px;
  min-height: 300px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  overflow: auto;
  color: #000;
}

.content {
  padding: 16px;
  border-radius: 4px;
  color: #000;
}

/* Dialog Actions */
mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

.summary-content {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  background: #fff;
  padding: 8px;
  border: 1px solid #000;
  font-family: "GothamNarrowBook", "GothamBook";
  font-size: 13px;
}

.summary-content table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 4px;
  overflow-x: auto;
  box-sizing: border-box;
  max-width: 100% ;
}

.summary-content th,
.summary-content td {
  border: 1px solid #000;
  padding: 2px 4px;
  font-size: 12px;
}

.summary-content th {
  font-weight: bold;
  text-align: center;
}

.bg-yellow {
  background-color: #faab18;
}

.bg-gray {
  background-color: #d9d9d9;
}

.bg-orange {
  background-color: #e5601f;
}

.white-text {
  color: #000;
}

.notes-section {
  padding: 4px;
  border: 1px solid #000;
  margin-bottom: 4px;
  font-size: 11px;
}

.test-table .bg-green {
  background-color: #b2cc34;
  text-align: center;
  font-weight: bold;
}

.test-table .bg-cyan {
  background-color: #00b2bd;
  text-align: center;
  font-weight: bold;
  color: #000;
}

.test-table .bg-orange {
  background-color: #faab18;
}

.rheology-table th {
  text-align: center;
  font-weight: bold;
}

.test-table tr.bg-red>th,
.rheology-table tr.bg-red>th {
  background-color: #e21836;
}

.test-table tr.bg-gray>th,
.rheology-table tr.bg-gray>th {
  background-color: #ba3093;
}
.test-table tr.bg-blue>th {
  background-color: #009DD9;
}
.test-table td,
.rheology-table td {
  text-align: center;
}

.tables-container {
  display: flex;
  width: 100%;
  gap: 0;
}

.test-table {
  width: 100%;
  border-collapse: collapse;
}

.empty-table {
  width: 100%;
  min-height: 120px;
  border: 1px solid #000;
}

.custom-mix-table {
  width: 100%;
  border: 1px solid #000;
  border-collapse: collapse;
  font-size: 14px;
  background-color: #FAAB18;
}

.custom-mix-table td {
  border: none;
  padding: 4px 6px;
  vertical-align: top;
  line-height: 1.2;
}

.inline-item {
  display: inline;
  margin-right: 12px;
  white-space: normal;
}

.mixability-row td {
  border-bottom: 1px solid #000 !important;
}


/* ── Window-style titlebar with minimize/maximize/close ────────── */
.summary-report-titlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px 6px 16px;
  margin: -24px -24px 12px -24px; /* offset default mat-dialog padding */
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  font-weight: 600;
  font-size: 16px;
  -webkit-user-select: none;
          user-select: none;
}
.summary-report-titlebar .title-text { flex: 1; }
.summary-report-titlebar .window-controls {
  display: inline-flex;
  gap: 2px;
}
.summary-report-titlebar .win-btn {
  background: transparent;
  border: none;
  width: 34px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px;
  color: #333;
}
.summary-report-titlebar .win-btn:hover { background: #e5e5e5; }
.summary-report-titlebar .win-btn.win-close:hover { background: #e81123; color: #fff; }
.summary-report-titlebar .win-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}

/* Titlebar with minimize/maximize/close */
.summary-report-titlebar { display: flex; align-items: center; justify-content: space-between; padding: 6px 12px; margin: -24px -24px 12px -24px; border-bottom: 1px solid #e0e0e0; background: #f8f9fa; font-weight: 600; font-size: 16px; -webkit-user-select: none; user-select: none; }
.summary-report-titlebar .title-text { flex: 1; }
.summary-report-titlebar .window-controls { display: inline-flex; gap: 2px; }
.summary-report-titlebar .win-btn { background: transparent; border: none; width: 34px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; border-radius: 2px; color: #333; }
.summary-report-titlebar .win-btn:hover { background: #e5e5e5; }
.summary-report-titlebar .win-btn.win-close:hover { background: #e81123; color: #fff; }
.summary-report-titlebar .win-btn mat-icon { font-size: 18px; width: 18px; height: 18px; line-height: 18px; }

/* ── Summary Report dialog: maximize / minimize panel classes ──
   These target the CDK overlay pane, which lives outside this component's
   DOM. \`::ng-deep\` is used so the styles pierce Angular view encapsulation. */
::ng-deep .cdk-overlay-pane.summary-report-maximized {
  max-width: 100vw !important;
  max-height: 100vh !important;
  width: 100vw !important;
  height: 100vh !important;
}
/* Make the dialog surface and its content fill the entire viewport when maximized */
::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-container,
::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-surface,
::ng-deep .cdk-overlay-pane.summary-report-maximized .mdc-dialog__surface {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
}
::ng-deep .cdk-overlay-pane.summary-report-maximized mat-dialog-content,
::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-content {
  max-width: none !important;
  min-width: 0 !important;
  width: 100% !important;
  max-height: none !important;
}
/* Override the fixed 1100px cap on the inner summary content */
::ng-deep .cdk-overlay-pane.summary-report-maximized .summary-content {
  max-width: none !important;
  width: 100% !important;
}

::ng-deep .cdk-overlay-pane.summary-report-minimized {
  max-width: 320px !important;
  width: 320px !important;
  height: auto !important;
  min-height: 0 !important;
}
::ng-deep .cdk-overlay-pane.summary-report-minimized .mat-mdc-dialog-container {
  min-height: 0 !important;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/summary-report/summary-report.component.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,mBAAmB;AACnB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,MAAM;AACR;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B,EAAE,sCAAsC;EACtE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,uCAAuC,OAAO,EAAE;AAChD;EACE,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,oDAAoD,mBAAmB,EAAE,WAAW,EAAE;AACtF;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,iBAAiB,EAAE,8BAA8B,EAAE,gCAAgC,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,eAAe,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;AAC/P,uCAAuC,OAAO,EAAE;AAChD,4CAA4C,oBAAoB,EAAE,QAAQ,EAAE;AAC5E,oCAAoC,uBAAuB,EAAE,YAAY,EAAE,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,kBAAkB,EAAE,WAAW,EAAE;AAC5N,0CAA0C,mBAAmB,EAAE;AAC/D,oDAAoD,mBAAmB,EAAE,WAAW,EAAE;AACtF,6CAA6C,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAE5G;;8EAE8E;AAC9E;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;AAC1B;AACA,oFAAoF;AACpF;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA,+DAA+D;AAC/D;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Dialog Title */\n\n/* Dialog Content */\nmat-dialog-content {\n  min-width: 1100px;\n  min-height: 300px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  overflow: auto;\n  color: #000;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n  color: #000;\n}\n\n/* Dialog Actions */\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.summary-content {\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  background: #fff;\n  padding: 8px;\n  border: 1px solid #000;\n  font-family: \"GothamNarrowBook\", \"GothamBook\";\n  font-size: 13px;\n}\n\n.summary-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 4px;\n  overflow-x: auto;\n  box-sizing: border-box;\n  max-width: 100% ;\n}\n\n.summary-content th,\n.summary-content td {\n  border: 1px solid #000;\n  padding: 2px 4px;\n  font-size: 12px;\n}\n\n.summary-content th {\n  font-weight: bold;\n  text-align: center;\n}\n\n.bg-yellow {\n  background-color: #faab18;\n}\n\n.bg-gray {\n  background-color: #d9d9d9;\n}\n\n.bg-orange {\n  background-color: #e5601f;\n}\n\n.white-text {\n  color: #000;\n}\n\n.notes-section {\n  padding: 4px;\n  border: 1px solid #000;\n  margin-bottom: 4px;\n  font-size: 11px;\n}\n\n.test-table .bg-green {\n  background-color: #b2cc34;\n  text-align: center;\n  font-weight: bold;\n}\n\n.test-table .bg-cyan {\n  background-color: #00b2bd;\n  text-align: center;\n  font-weight: bold;\n  color: #000;\n}\n\n.test-table .bg-orange {\n  background-color: #faab18;\n}\n\n.rheology-table th {\n  text-align: center;\n  font-weight: bold;\n}\n\n.test-table tr.bg-red>th,\n.rheology-table tr.bg-red>th {\n  background-color: #e21836;\n}\n\n.test-table tr.bg-gray>th,\n.rheology-table tr.bg-gray>th {\n  background-color: #ba3093;\n}\n.test-table tr.bg-blue>th {\n  background-color: #009DD9;\n}\n.test-table td,\n.rheology-table td {\n  text-align: center;\n}\n\n.tables-container {\n  display: flex;\n  width: 100%;\n  gap: 0;\n}\n\n.test-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.empty-table {\n  width: 100%;\n  min-height: 120px;\n  border: 1px solid #000;\n}\n\n.custom-mix-table {\n  width: 100%;\n  border: 1px solid #000;\n  border-collapse: collapse;\n  font-size: 14px;\n  background-color: #FAAB18;\n}\n\n.custom-mix-table td {\n  border: none;\n  padding: 4px 6px;\n  vertical-align: top;\n  line-height: 1.2;\n}\n\n.inline-item {\n  display: inline;\n  margin-right: 12px;\n  white-space: normal;\n}\n\n.mixability-row td {\n  border-bottom: 1px solid #000 !important;\n}\n\n\n/* ── Window-style titlebar with minimize/maximize/close ────────── */\n.summary-report-titlebar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 12px 6px 16px;\n  margin: -24px -24px 12px -24px; /* offset default mat-dialog padding */\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n  font-weight: 600;\n  font-size: 16px;\n  user-select: none;\n}\n.summary-report-titlebar .title-text { flex: 1; }\n.summary-report-titlebar .window-controls {\n  display: inline-flex;\n  gap: 2px;\n}\n.summary-report-titlebar .win-btn {\n  background: transparent;\n  border: none;\n  width: 34px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 2px;\n  color: #333;\n}\n.summary-report-titlebar .win-btn:hover { background: #e5e5e5; }\n.summary-report-titlebar .win-btn.win-close:hover { background: #e81123; color: #fff; }\n.summary-report-titlebar .win-btn mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n\n/* Titlebar with minimize/maximize/close */\n.summary-report-titlebar { display: flex; align-items: center; justify-content: space-between; padding: 6px 12px; margin: -24px -24px 12px -24px; border-bottom: 1px solid #e0e0e0; background: #f8f9fa; font-weight: 600; font-size: 16px; user-select: none; }\n.summary-report-titlebar .title-text { flex: 1; }\n.summary-report-titlebar .window-controls { display: inline-flex; gap: 2px; }\n.summary-report-titlebar .win-btn { background: transparent; border: none; width: 34px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; border-radius: 2px; color: #333; }\n.summary-report-titlebar .win-btn:hover { background: #e5e5e5; }\n.summary-report-titlebar .win-btn.win-close:hover { background: #e81123; color: #fff; }\n.summary-report-titlebar .win-btn mat-icon { font-size: 18px; width: 18px; height: 18px; line-height: 18px; }\n\n/* ── Summary Report dialog: maximize / minimize panel classes ──\n   These target the CDK overlay pane, which lives outside this component's\n   DOM. `::ng-deep` is used so the styles pierce Angular view encapsulation. */\n::ng-deep .cdk-overlay-pane.summary-report-maximized {\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  width: 100vw !important;\n  height: 100vh !important;\n}\n/* Make the dialog surface and its content fill the entire viewport when maximized */\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-container,\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-surface,\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mdc-dialog__surface {\n  width: 100vw !important;\n  height: 100vh !important;\n  max-width: 100vw !important;\n  max-height: 100vh !important;\n  border-radius: 0 !important;\n}\n::ng-deep .cdk-overlay-pane.summary-report-maximized mat-dialog-content,\n::ng-deep .cdk-overlay-pane.summary-report-maximized .mat-mdc-dialog-content {\n  max-width: none !important;\n  min-width: 0 !important;\n  width: 100% !important;\n  max-height: none !important;\n}\n/* Override the fixed 1100px cap on the inner summary content */\n::ng-deep .cdk-overlay-pane.summary-report-maximized .summary-content {\n  max-width: none !important;\n  width: 100% !important;\n}\n\n::ng-deep .cdk-overlay-pane.summary-report-minimized {\n  max-width: 320px !important;\n  width: 320px !important;\n  height: auto !important;\n  min-height: 0 !important;\n}\n::ng-deep .cdk-overlay-pane.summary-report-minimized .mat-mdc-dialog-container {\n  min-height: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
